export default import.meta.ROLLDOWN_FILE_URL_Cjpm4nakhIL_1e0a80RZ_Q